import { Users } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo, SaidaPadrao } from './node-chrome';

/**
 * Bloco descontinuado. Nunca existiu no motor: era espelhado como mensagem
 * vazia e derrubava a execução inteira ali. Hoje vira passagem, e continua
 * sem fazer nada — por isso saiu da paleta e o cartão avisa.
 *
 * O componente fica para desenhar fluxos antigos que ainda o tenham.
 */
export default function TargetNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="target"
        dados={data}
        icone={Users}
        corDoTopo="bg-gray-400"
        corDoIcone="text-gray-500"
        titulo={data.label || 'Público-Alvo'}
      />
      <SaidaPadrao />
    </>
  );
}
